export function adminDepositShowTabularColumn() {
  return [
    {
      name: 'id',
      title: 'شماره واریزی'
    },
    {
      name: 'payable_type',
      title: 'نوع واریزی'
    },
    {
      name: 'created_at',
      title: 'تاریخ ایجاد'
    },
    {
      name: 'status',
      title: 'وضعیت'
    },
    {
      name: 'paid_at',
      title: 'تاریخ پرداخت'
    },
    {
      name: 'account_type',
      title: 'نوع حساب'
    }
  ]
}